import React from "react";
import { Edit2 } from "@piiqtechnologies/svg-icons";
import { TableActionButton } from "@common-components/table";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
export const CommunitiesActions = ({ onEdit }) => {
    const intl = useIntl();
    return [
        React.createElement(TableActionButton, { "aria-label": "edit", key: "edit-community", "data-testid": "edit-community", onClick: onEdit, Icon: Edit2, tooltip: intl.formatMessage(messages.actionsEdit) }),
    ];
};
export default CommunitiesActions;
